export default __webpack_public_path__ + "static/media/RedHatDisplay-SemiBold.a09738a4.ttf";